import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./TechForge.css";
import techForgeBg from "../assets/techology-it.jpg";


function TechForge() {
 const services = [
  {
    title: "Software Development",
    desc: "Custom enterprise software, web & mobile applications, scalable platforms.",
    icon: "https://img.icons8.com/fluency/96/code.png",
  },
  {
    title: "Artificial Intelligence",
    desc: "AI/ML solutions, predictive analytics, chatbots, and automation systems.",
    icon: "https://img.icons8.com/fluency/96/artificial-intelligence.png",
  },
  {
    title: "UI/UX Design",
    desc: "Premium user-centric designs, interactive prototypes, and digital branding.",
    icon: "https://img.icons8.com/fluency/96/design.png",
  },
  {
    title: "Quality Testing",
    desc: "Comprehensive QA, automated testing, and performance optimization.",
    icon: "https://img.icons8.com/fluency/96/test-passed.png",
  },
  {
    title: "Cloud & DevOps",
    desc: "Cloud deployment, CI/CD pipelines, and scalable infrastructure solutions.",
    icon: "https://img.icons8.com/fluency/96/cloud.png",
  },
  {
    title: "Cybersecurity",
    desc: "End-to-end security solutions, penetration testing, and threat monitoring.",
    icon: "https://img.icons8.com/fluency/96/security-checked.png",
  },
  {
    title: "Data Analytics & BI",
    desc: "Business intelligence dashboards, predictive analytics, and data visualization solutions.",
    icon: "https://img.icons8.com/fluency/96/combo-chart.png",
  },
  {
    title: "Mobile App Development",
    desc: "iOS & Android app development with high performance and intuitive design.",
    icon: "https://img.icons8.com/fluency/96/smartphone.png",
  },
];


const projects = [
  {
    name: "Smart Logistics Platform",
    desc: "Optimized fleet and supply chain management using AI-driven analytics.",
    img: "https://picsum.photos/seed/logistics/400/250",
  },
  {
    name: "Healthcare App Suite",
    desc: "Telemedicine and diagnostics solution for modern healthcare delivery.",
    img: "https://picsum.photos/seed/healthcare/400/250",
  },
  {
    name: "E-commerce Enterprise",
    desc: "End-to-end e-commerce platform with secure payments and analytics.",
    img: "https://picsum.photos/seed/ecommerce/400/250",
  },
];


  return (
    <>
      <Navbar />

      {/* HERO SECTION */}
   <section
  className="techforge-hero"
  style={{
    backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url(${techForgeBg})`,
  }}
>
  <div className="hero-content">
    <h1>Klyzen </h1>
    <p>Innovating Technology, Empowering Enterprises</p>
  </div>
</section>



      {/* ABOUT SECTION */}
      <section className="techforge-about">
        <div className="container">
          <h2>About Klyzen </h2>
          <p>
             Klyzen Ventures LLP is at the forefront
            of technology innovation. We specialize in software development, AI solutions,
            UI/UX design, cloud computing, cybersecurity, and quality testing to help
            enterprises scale efficiently and stay competitive in a digital-first world.
          </p>
        </div>
      </section>

      {/* SERVICES SECTION */}
      <section className="techforge-services">
        <div className="container">
          <h2>Our Expertise</h2>
          <div className="services-grid">
            {services.map((service, idx) => (
              <div key={idx} className="service-card">
                <img src={service.icon} alt={service.title} />
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROJECTS SECTION */}
      <section className="techforge-projects">
        <div className="container">
          <h2>Featured Projects</h2>
          <div className="projects-grid">
            {projects.map((project, idx) => (
              <div key={idx} className="project-card">
                <img src={project.img} alt={project.name} />
                <div className="project-content">
                  <h3>{project.name}</h3>
                  <p>{project.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="techforge-cta">
        <div className="container">
          <h2>Partner with Klyzen TechForge</h2>
          <p>Transform your business with innovative technology solutions.</p>
          <a href="/contact" className="cta-btn">
            Get in Touch
          </a>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default TechForge;
